import { useCallback } from "react";
import { logoutRequest } from "../utils/api";

type UseLogoutOptions = {
  onAfter?: () => void;
};

export function useLogout(opts: UseLogoutOptions = {}) {
  const { onAfter } = opts;
  return useCallback(() => {
    logoutRequest().finally(() => {
      onAfter?.();
    });
  }, [onAfter]);
}

